import { useState, useEffect } from 'react';
import { http, authHeaders, STRICT_TOKEN_PREFIX } from '@loyalup/core';

const now = () => Date.now() / 1000;

const storeToken = (type, token) => {
  localStorage.setItem(`${STRICT_TOKEN_PREFIX}-${type}`, JSON.stringify(token));
};

const tokenFromCache = type => {
  const item = localStorage.getItem(`${STRICT_TOKEN_PREFIX}-${type}`);
  if (!item) return undefined;

  const data = JSON.parse(item);

  if (!data.token || data.expires < now()) return undefined;
  return data;
};

const fetchToken = async type => {
  let token = tokenFromCache(type);
  if (token) return token;
  const headers = await authHeaders();
  token = await http('POST', '/tokens', { type: type }, headers);
  storeToken(type, token);
  return token;
};

const useToken = type => {
  const [token, setToken] = useState();
  let timer;

  const fetchAndControlToken = async () => {
    const { token, expires } = await fetchToken(type);
    setToken(token);
    timer = setTimeout(fetchAndControlToken, expires - now());
  };

  useEffect(() => {
    fetchAndControlToken();

    return () => {
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return token;
};

export default useToken;
